import React, { useRef } from 'react';
import Select from '../../UI/Select';
import TextInput from '../../UI/TextInput';
import TextArea from '../../UI/TextArea';

const InternalModalContent = ({ register, onChangeHandler }) => {
  const handleMultiChange = (value) => {
    onChangeHandler(value);
    document.activeElement.blur()
  }

  return (
    <>
      <h5 className="mb-4 text-center">Send an Internal Message</h5>
      <fieldset>
        <label htmlFor="receiver">Recipient</label>
        <Select 
          handleMultiChange={handleMultiChange}
          name="receiver"
          list={
            [
              {value: "all", label: "All"},
              {value: "admin", label: "Admin"},
              {value: "business", label: "Business"},
              {value: "officer", label: "Officer"}
            ]
          }
          styles="react-select-input-container"
          prefixStyles="react-select-input"
          indicator={false}
          isSearchable={false}
          isClear={false}
          defaultValue={{value: "all", label: "All"}}
        />
      </fieldset>
      <fieldset>
        <label htmlFor="subject">Subject</label>
        <TextInput 
          name="subject" 
          register={register()}
          required={true}
        />
      </fieldset>
      <fieldset>
        <label htmlFor="body">Message</label>
        <TextArea 
          name="body" 
          register={register()}
          required={true}
        />
      </fieldset>
    </>
  )
}

export default InternalModalContent;